import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
//import IndexPage from "../../pages/IndexPage";
import TutorDashboardPage from "./../../pages/TutorDashboardPage";
import StudentDashboardPage from "../../pages/StudentDashboard/index";
import TutorInterestContainer from "./../../pages/TutorInterestContainer";
import TutorSubjectForm from "./../forms/tutorSubjectForm";
import QualificationForm from "./../forms/qualificationForm";
import ModeForTeach from "./../forms/ModeForTeach";
import TutorApplicationContainer from "../../pages/TutorApplicationContainer";
import TutorList from "./../../pages/TutorList";
import SpecificTutor from "./../../pages/SpecficTutor/index";
import NavbarAfterLogin from "../modals/NavbarAfterLogin";
import StudentNavbar from "../modals/StudentNavbar";
import AthenticateRoutes from "./../privateRoute";
import NotFoundPage from "./../NotFoundPage";
import BookingRequest from "./../../pages/SpecficTutor/BookingRequest";
import RequestSession from "./../../pages/SpecficTutor/requestSession";
import ReviewAndPay from "./../../pages/SpecficTutor/ReviewAndPay";
import TutorMainPageSetting from "./../../pages/TutorSetting/TutorMainPageSetting";
import ServiceAndRefundPolicy from "./../../pages/TutorApplicationForm/ServiceAndRefundPolicy";
import UkSelfEmpLaw from "./../../pages/TutorApplicationForm/UkSelfEmpLaw";
import PaymentTerms from "./../../pages/TutorSetting/PaymentTerms";
import HelpCenter from "./../../pages/TutorSetting/HelpCenter";
import TutorSettingBioAndSub from "./../../pages/TutorSetting/TutorSettingBioAndSub/index";
import SubjectSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/SubjectSetting";
import ModeofTutorSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/ModeofTutorSetting";
import ProfileBioSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/ProfileBioSetting";
import EducationSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/EducationSetting";
import WorkSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/WorkSetting";
import HourlyRateSetting from "./../../pages/TutorSetting/TutorSettingBioAndSub/HourlyRateSetting";
import ProfileStatus from "./../../pages/TutorSetting/TutorSettingBioAndSub/ProfileStatus";
import PreviewProfile from "./../../pages/TutorSetting/PreviewProfile";
import TutorLearnMore from "./../../pages/TutorLearnMore";
import Inbox from "./../../pages/TutorInbox";
import InboxDetails from "./../../pages/InboxDetails";
import Dashboard from "./../../pages/TutorDashboard/index";
import Lesson from "./../../pages/TutorLesson";
import Availability from "./../../pages/TutorAvailability";
import lessonDetails from "./../../pages/lessonDetails";
import PersonalInformation from "./../../pages/TutorSetting/PersonalInformation";
import ChangePasswordSetting from "./../../pages/TutorSetting/ChangePasswordSetting";
import TutorSettingIdentification from "./../../pages/TutorSetting/TutorSettingIdentification";
import PaymentDetail from "./../../pages/TutorSetting/PaymentDetail";
import TutorSettingNotification from "./../../pages/TutorSetting/TutorSettingNotification";
import TutorSettingDoctoralCertificate from "./../../pages/TutorSetting/TutorSettingDoctoralCertificate";
import TutorSettingbackgroundCheck from "./../../pages/TutorSetting/TutorSettingbackgroundCheck";

//admin-pages

import AdminDashboard from "./../../pages/AdminDashboard/index";
import AdminSpecificTutor from "./../../pages/AdminSpecificTutor/AdminSpecificTutor";

//become-a-tutor pages
import BecomeTutor from "../../pages/BecomeTutor/Becometutor";
import TutorSetup from "../../pages/TutorSetup/TutorSetup";
import TutorEarning from "../../pages/TutorEarning/TutorEarning";
import TutorStories from "../../pages/TutorStories/TutorStories";

//
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import axios from "axios";
import jwtDecode from "jwt-decode";
import TutorResult from "../../pages/TutorResult/index";
import Home from "../../pages/Home/Home";

axios.defaults.baseURL =
  // "http://localhost:5001/askademia-36826/us-central1/api";
  // axios.defaults.baseURL =
  "https://us-central1-askademia-36826.cloudfunctions.net/api";

const token = localStorage.FBIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    // Redirect user to login home page and tell them session expired,
    // we can request a new session on user's behalf
    // store.dispatch(logoutUser());
    // window.location.href = "/login";
  } else {
    // store.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common["Authorization"] = token;
    // store.dispatch(getUserData());
  }
}

//function IndexPageRender() {
//  return <IndexPage />;
//}

class App extends Component {
  constructor() {
    super();
    this.state = {
      user: {},
      loginAlert: false,
    };
  }

  sucssesLogin = (data) => {
    localStorage.setItem("userDetail", JSON?.stringify(data.data));
    this.setState({
      user: data.data,
    });
  };

  changeRoute = () => {
    localStorage.clear();
    this.setState({
      user: {},
    });
  };

  componentDidMount() {
    const token = localStorage.getItem("FBIdToken");
    axios.defaults.headers.common["Authorization"] = token;
  }

  TutorDashboardPage = () => {
    return <TutorDashboardPage LogOut={this.LogOut} />;
  };

  render() {
    const { user } = this.props;
    let isTutor = user?.user?.isTutor;
    const token = localStorage.getItem("FBIdToken")
      ? localStorage.getItem("FBIdToken")
      : "";
    return (
      <Router>
        <div>
          {token ? (
            <Route
              exact
              path={[
                "/tutor-application-form",
                "/tutor-application-form/Subject",
                "/tutor-application-form/modeForTeach",
                "/tutor-application-form/qualificationForm",
                "/tutor-dashboard/home",
                "/tutor-dashboard/inbox",
                "/tutor-dashboard/InboxDetails",
                "/tutor-dashboard/lesson",
                "/tutor-dashboard/lessonDetails",
                "/tutor-dashboard/availability",
                "/tutoring-interest",
                "/tutors/search/",
                "/tutors/search/tutor/:id",
                "/tutors/search/tutor/:id/:tag",
                "/tutors/search/tutor/:id/learn-more",
                "/tutor-dashboard/TutorSettingBioAndSub",
                "/tutor-dashboard/TutorSettingBioAndSub/edit-subject",
                "/tutor-dashboard/TutorSettingBioAndSub/ModeofTutorSetting",
                "/tutor-dashboard/TutorSettingBioAndSub/ProfileBioSetting",
                "/tutor-dashboard/TutorSettingBioAndSub/EducationSetting",
                "/tutor-dashboard/TutorSettingBioAndSub/WorkSetting",
                "/tutor-dashboard/TutorSettingBioAndSub/HourlyRateSetting",
                "/tutor-dashboard/TutorSettingBioAndSub/ProfileStatus",
                "/tutor-dashboard/profile",
                "/student-dashboard",
                "/student-dashboard/inbox",
                "/tutor-dashboard/result",
                
                //tutor setting
                "/tutor-setting",
                "/tutor-setting/certificates",
                "/tutor-setting/notifications",
                "/tutor-setting/identification",
                "/tutor-setting/payment-details",
                "/tutor-setting/change-password",
                "/tutor-setting/background-check",
                "/tutor-setting/personal-information",
                "/tutor-setting/payment-details/help-center",
                "/tutor-setting/payment-details/payment-terms-of-service",
              ]}
              render={(props) => (
                <Row className="flex-center-center m-0">
                  <Col
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="p-0"
                    style={{ width: "100%" }}
                  >
                    {isTutor ? (
                      <NavbarAfterLogin
                        changeRoute={this.changeRoute}
                        {...props}
                      />
                    ) : (
                      <StudentNavbar
                        changeRoute={this.changeRoute}
                        {...props}
                      />
                    )}
                  </Col>
                </Row>
              )}
            />
          ) : (
            <Route
              path={[
                "/",
                "/tutors/search/",
                "/tutors/search/tutor/:id",
                "/tutors/search/tutor/:id/:tag",
                "/tutors/search/tutor/:id/learn-more",
              ]}
              exact
              render={(props) => (
                <Header
                  loginAlert={this.state.loginAlert}
                  sucssesLogin={this.sucssesLogin}
                  loginAlertHide={() => this.setState({ loginAlert: false })}
                  {...props}
                />
              )}
            />
          )}
          <Row className="flex-center-center m-0">
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="p-0"
              style={{ width: "100%" }}
            >
              <Switch>
                <Route path="/" exact component={Home} />
                <Route
                  exact
                  path="/become-a-tutor/overview"
                  component={BecomeTutor}
                />
                <Route
                  exact
                  path="/become-a-tutor/setup"
                  component={TutorSetup}
                />
                <Route
                  exact
                  path="/become-a-tutor/earnings"
                  component={TutorEarning}
                />
                <Route
                  exact
                  path="/become-a-tutor/stories"
                  component={TutorStories}
                />
                <Route
                  exact
                  path="/admin"
                  component={AdminDashboard}
                />
                <Route
                  exact
                  path="/admin-specific-tutor"
                  component={AdminSpecificTutor}
                />
                <AthenticateRoutes
                  exact
                  path="/student-dashboard"
                  token={token}
                  changeRoute={this.changeRoute}
                  component={StudentDashboardPage}
                />
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/home"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={Dashboard}
                />
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/inbox"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={Inbox}
                />
                <AthenticateRoutes
                  exact
                  path="/student-dashboard/inbox"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={Inbox}
                />{" "}
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/InboxDetails"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={InboxDetails}
                />{" "}
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/lesson"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={Lesson}
                />
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/result"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={TutorResult}
                />
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/lessonDetails"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={lessonDetails}
                />
                <AthenticateRoutes
                  exact
                  path="/tutor-dashboard/availability"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={Availability}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSettingBioAndSub}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/edit-subject"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={SubjectSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/ModeofTutorSetting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ModeofTutorSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/ProfileBioSetting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ProfileBioSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/EducationSetting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={EducationSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/WorkSetting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={WorkSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/HourlyRateSetting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={HourlyRateSetting}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/TutorSettingBioAndSub/ProfileStatus"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ProfileStatus}
                />
                <AthenticateRoutes
                  path="/tutor-application-form"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorApplicationContainer}
                />
                <AthenticateRoutes
                  path="/tutoring-interest"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  component={TutorInterestContainer}
                />
                <AthenticateRoutes
                  path="/tutor-application-form/Subject"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSubjectForm}
                />
                <AthenticateRoutes
                  path="/tutor-application-form/modeForTeach"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ModeForTeach}
                />
                {/* QualificationForm */}
                <AthenticateRoutes
                  path="/tutor-application-form/qualificationForm"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={QualificationForm}
                />
                <AthenticateRoutes
                  path="/Service-and-refundPolicy"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ServiceAndRefundPolicy}
                />
                <AthenticateRoutes
                  path="/Uk-Self-EmpLaw"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={UkSelfEmpLaw}
                />
                {/* TutorMainPageSetting */}
                <AthenticateRoutes
                  path="/tutor-setting"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorMainPageSetting}
                />
                <AthenticateRoutes
                  path="/tutor-setting/payment-details/payment-terms-of-service"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={PaymentTerms}
                />
                <AthenticateRoutes
                  path="/tutor-setting/payment-details/help-center"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={HelpCenter}
                />
                <AthenticateRoutes
                  path="/tutor-dashboard/profile"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={PreviewProfile}
                />
                <AthenticateRoutes
                  path="/tutor-setting/personal-information"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={PersonalInformation}
                />
                <AthenticateRoutes
                  path="/tutor-setting/change-password"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={ChangePasswordSetting}
                />
                <AthenticateRoutes
                  path="/tutor-setting/identification"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSettingIdentification}
                />
                <AthenticateRoutes
                  path="/tutor-setting/notifications"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSettingNotification}
                />
                <AthenticateRoutes
                  path="/tutor-setting/certificates"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSettingDoctoralCertificate}
                />
                <AthenticateRoutes
                  path="/tutor-setting/background-check"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={TutorSettingbackgroundCheck}
                />
                <AthenticateRoutes
                  path="/tutor-setting/payment-details"
                  showAlert={() => this.setState({ loginAlert: true })}
                  token={token}
                  {...this.props}
                  exact
                  component={PaymentDetail}
                />
                {/* TutorList */}
                <Route
                  exact
                  path="/tutors/search"
                  {...this.props}
                  component={TutorList}
                />
                <Route
                  exact
                  path="/tutors/search/tutor/:id"
                  {...this.props}
                  component={SpecificTutor}
                />
                <Route
                  exact
                  path="/tutors/search/tutor/:id/learn-more"
                  {...this.props}
                  component={TutorLearnMore}
                />
                <Route
                  exact
                  path="/tutors/search/tutor/:id/booking-request"
                  {...this.props}
                  component={BookingRequest}
                />
                <Route
                  exact
                  path="/tutors/search/tutor/:id/request-session"
                  {...this.props}
                  component={RequestSession}
                />
                <Route
                  exact
                  path="/tutors/search/tutor/:id/review-pay"
                  {...this.props}
                  component={ReviewAndPay}
                />
                <Route
                  exact
                  path="*"
                  render={(props) => <NotFoundPage props={props} />}
                />
              </Switch>
            </Col>
          </Row>
          <footer>
            <Footer />
          </footer>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    UserReducer: { user },
  } = state;
  return {
    user,
  };
};

export default connect(mapStateToProps, null)(withRouter(App));
